<div class="public-form-container">
  <p-toast position="top-right"></p-toast>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration="0.8s">
      </p-progressSpinner>
      <p class="loading-text">Loading your form...</p>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-card">
      <div class="error-icon-wrapper">
        <i class="pi pi-exclamation-circle"></i>
      </div>
      <h2 class="error-title">Oops! Form Not Available</h2>
      <p class="error-message">{{ error }}</p>
      <p class="error-hint">Please check your link or contact support if the issue persists.</p>
    </div>
  </div>

  <!-- Success State -->
  <div *ngIf="submitted && !loading" class="success-container">
    <div class="success-card">
      <div class="success-animation">
        <div class="success-checkmark">
          <i class="pi pi-check"></i>
        </div>
      </div>
      <h2 class="success-title">Thank You!</h2>
      <p class="success-message">Your response has been successfully submitted.</p>
      <p class="success-subtitle">We appreciate your time and will get back to you soon.</p>
      <button type="button" class="submit-another-btn" (click)="submitted = false; resetForm()">
        <i class="pi pi-refresh mr-2"></i>
        Submit Another Response
      </button>
    </div>
  </div>

  <!-- Form State -->
  <div *ngIf="formData && !loading && !submitted" class="form-wrapper">
    <!-- Compact Form Header -->
    <div class="form-header">
      <div class="header-content">
        <h1 class="form-title">{{ formData.form_name }}</h1>
        <p *ngIf="formData.description" class="form-description">{{ formData.description }}</p>
      </div>
    </div>

    <!-- Scrollable Form Content -->
    <div class="form-content-scroll">
      <div class="form-card">
        <!-- Dynamic Form Fields with Row/Column Layout -->
        <form [formGroup]="dynamicForm" (ngSubmit)="submitForm()" id="dynamicForm">

          <!-- Iterate over rows -->
          <div *ngFor="let row of formRows" class="form-row">
            <div class="grid gap-4" [ngClass]="getGridClass(row.columns)">

              <!-- Iterate over fields in row -->
              <div *ngFor="let fieldConfig of row.fields" class="form-field">

                <!-- Text Input -->
                <div *ngIf="fieldConfig.ui_type === 'text'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <input pInputText [id]="getFieldIdAsString(fieldConfig.field_id)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || ''" class="w-full"
                    [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Textarea -->
                <div *ngIf="fieldConfig.ui_type === 'textarea'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <textarea pTextarea [id]="getFieldIdAsString(fieldConfig.field_id)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || ''" rows="4" class="w-full"
                    [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
            </textarea>
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Email Input -->
                <div *ngIf="fieldConfig.ui_type === 'email'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <input pInputText type="email" [id]="getFieldIdAsString(fieldConfig.field_id)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || 'email@example.com'" class="w-full"
                    [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Phone Input -->
                <div *ngIf="fieldConfig.ui_type === 'tel'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <input pInputText type="tel" [id]="getFieldIdAsString(fieldConfig.field_id)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || ''" class="w-full"
                    [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Number Input -->
                <div *ngIf="fieldConfig.ui_type === 'number'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <p-inputNumber [inputId]="getFieldIdAsString(fieldConfig.field_id)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || ''" styleClass="w-full"
                    [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
                  </p-inputNumber>
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Date Input -->
                <div *ngIf="fieldConfig.ui_type === 'date'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <p-calendar [inputId]="getFieldIdAsString(fieldConfig.field_id)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    appendTo="body"
                    [placeholder]="fieldConfig.placeholder || 'Select date'" dateFormat="dd/mm/yy" [showIcon]="true"
                    styleClass="w-full" [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
                  </p-calendar>
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Checkbox -->
                <div *ngIf="fieldConfig.ui_type === 'checkbox'" class="field">
                  <div class="flex items-center gap-3">
                    <p-checkbox [inputId]="getFieldIdAsString(fieldConfig.field_id)"
                      [formControlName]="getFieldIdAsString(fieldConfig.field_id)" [binary]="true">
                    </p-checkbox>
                    <label [for]="getFieldIdAsString(fieldConfig.field_id)" class="font-semibold cursor-pointer">
                      {{ getFieldLabel(fieldConfig) }}
                      <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                    </label>
                  </div>
                  <small *ngIf="fieldConfig.help_text" class="block mt-2 ml-10 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 ml-10 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- Dropdown Select -->
                <div *ngIf="fieldConfig.ui_type === 'select'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <p-select [inputId]="getFieldIdAsString(fieldConfig.field_id)"
                    [options]="getFieldOptions(fieldConfig)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || 'Select an option'" optionLabel="label"
                    optionValue="value" [showClear]="!fieldConfig.is_required" styleClass="w-full"
                    [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)"
                    appendTo="body"
                    >
                  </p-select>
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

                <!-- NORMAL RADIO BUTTON (100% WORKING) -->
                <!-- NORMAL RADIO BUTTON (ANGULAR-CORRECT) -->
              <div *ngIf="fieldConfig.ui_type === 'radio'" class="field"
  style="margin-bottom:16px;">

  <label class="block font-semibold mb-2"
    style="display:block;font-weight:600;margin-bottom:8px;font-size:14px;color:#111827; margin-bottom: 10px;">
    {{ getFieldLabel(fieldConfig) }}
    <span *ngIf="fieldConfig.is_required" style="color:#ef4444;">*</span>
  </label>

  <div style="display:flex;flex-direction:column;gap:8px;">
    <label *ngFor="let option of getFieldOptions(fieldConfig)"
      style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:14px;color:#374151;">

      <input
        type="radio"
        class="form-radio"
        [name]="getFieldIdAsString(fieldConfig.field_id)"
        [checked]="dynamicForm.get(getFieldIdAsString(fieldConfig.field_id))?.value === option.value"
        (change)="onNativeRadioChange(fieldConfig.field_id, option.value)"
        style="
          width:16px;
          height:16px;
          cursor:pointer;
          accent-color:#2563eb;
        "
      />

      <span style="line-height:1.4;">
        {{ option.label }}
      </span>
    </label>
  </div>

  <small *ngIf="isFieldInvalid(fieldConfig.field_id)"
    style="color:#dc2626;font-size:12px;margin-top:6px;display:block;">
    {{ getFieldError(fieldConfig.field_id) }}
  </small>
</div>




                <!-- Multi-Select -->
                <div *ngIf="fieldConfig.ui_type === 'multiselect'" class="field">
                  <label [for]="fieldConfig.field_id" class="block font-semibold mb-2">
                    {{ getFieldLabel(fieldConfig) }}
                    <span *ngIf="fieldConfig.is_required" class="text-red-500">*</span>
                  </label>
                  <p-multiSelect [inputId]="getFieldIdAsString(fieldConfig.field_id)"
                    [options]="getFieldOptions(fieldConfig)"
                    [formControlName]="getFieldIdAsString(fieldConfig.field_id)"
                    [placeholder]="fieldConfig.placeholder || 'Select options'" optionLabel="label" optionValue="value"
                    display="chip" styleClass="w-full" [class.ng-invalid]="isFieldInvalid(fieldConfig.field_id)"
                    [class.ng-dirty]="isFieldInvalid(fieldConfig.field_id)">
                  </p-multiSelect>
                  <small *ngIf="fieldConfig.help_text" class="block mt-1 text-gray-500">
                    {{ fieldConfig.help_text }}
                  </small>
                  <small *ngIf="isFieldInvalid(fieldConfig.field_id)" class="block mt-1 text-red-500">
                    {{ getFieldError(fieldConfig.field_id) }}
                  </small>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Fixed Form Footer with Actions -->
    <div class="form-footer-fixed">
      <div class="footer-content">
        <div class="footer-security">
          <i class="pi pi-shield"></i>
          <span>Your information is secure and will be handled with care</span>
        </div>
        <div class="form-actions">
          <button type="button" class="btn-reset" (click)="resetForm()">
            <i class="pi pi-refresh"></i>
            Reset Form
          </button>
          <button type="submit" form="dynamicForm" class="btn-submit" [disabled]="dynamicForm.invalid || submitting"
            [class.loading]="submitting">
            <i class="pi pi-send" *ngIf="!submitting"></i>
            <i class="pi pi-spin pi-spinner" *ngIf="submitting"></i>
            {{ submitting ? 'Submitting...' : 'Submit Form' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- No Form Available -->
  <div *ngIf="!formData && !loading && !error" class="no-form-container">
    <div class="no-form-card">
      <div class="no-form-icon-wrapper">
        <i class="pi pi-info-circle"></i>
      </div>
      <h2 class="no-form-title">No Form Available</h2>
      <p class="no-form-message">The form you are looking for is not available at the moment.</p>
      <p class="no-form-hint">Please check your link or contact support if you believe this is an error.</p>
    </div>
  </div>
</div>